import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'Vandaag',
    asap: 'ASAP',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Kamernummer',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Tafelnummer',
  },
};
